


// // import React, { useState } from "react";
// // import { Layout, Row, Col, Typography, Space, Modal, Collapse, Tag } from "antd";
// // import {
// //   UserOutlined, ReadOutlined, LineChartOutlined,
// //   QuestionCircleOutlined, TeamOutlined, FileTextOutlined,
// //   CloseOutlined, CrownOutlined, BookOutlined, ToolOutlined,
// //   CustomerServiceOutlined, RocketOutlined, HeartOutlined,
// //   GlobalOutlined, BulbOutlined, TrophyOutlined, StarOutlined,
// //   CheckCircleOutlined
// // } from "@ant-design/icons";
// // import { Link } from "react-router-dom";
// // import DedicatedAccessSection from "./admin_and_user/DedicatedAccessSection";
// // import CoursesByCategory from "./admin_and_user/CoursesByCategory";
// // import NewsSection from "./admin_and_user/NewsSection";

// // const { Content, Footer } = Layout;
// // const { Panel } = Collapse;

// // /* ============ Couleurs logo Nomidya ============ */
// // const C = {
// //   blue: "#0054A6",
// //   blueDark: "#003B75",
// //   blueLight: "#e8f1fb",
// //   orange: "#E8860C",
// //   orangeLight: "#FF8C00",
// //   orangeBg: "#fff8f0",
// //   white: "#ffffff",
// //   bg: "#f7f8fa",
// //   text: "#333",
// //   textLight: "#888",
// //   border: "#eaedf2",
// // };

// // /* ================================================================
// //    Modal — Notre Équipe
// //    ================================================================ */
// // const TeamModal = ({ visible, onClose }) => {
// //   const sections = [
// //     { title: "Nos Fondateurs", icon: <CrownOutlined />, color: C.orange,
// //       desc: "D'anciens consultants et gestionnaires dans des multinationales, qui ont fondé Nomidya avec la mission de partager leurs connaissances et expériences avec le monde." },
// //     { title: "Nos Formateurs", icon: <BookOutlined />, color: "#00875A",
// //       desc: "Soigneusement sélectionnés, ce sont des experts du secteur, dotés d'une vaste expérience pratique et d'une connaissance approfondie des sujets qu'ils enseignent." },
// //     { title: "Équipe Technique", icon: <ToolOutlined />, color: C.blue,
// //       desc: "Travaille sans relâche pour maintenir notre plateforme à la pointe de la technologie, en intégrant les dernières innovations et meilleures pratiques pédagogiques." },
// //     { title: "Support Apprenants", icon: <CustomerServiceOutlined />, color: "#DC2626",
// //       desc: "Là pour guider, accompagner et répondre aux questions de nos apprenants à chaque étape de leur parcours d'apprentissage." },
// //   ];

// //   return (
// //     <Modal open={visible} onCancel={onClose} footer={null} width={720}
// //       style={{ maxWidth: "95vw" }} centered
// //       closeIcon={<CloseOutlined style={{ color: C.textLight }} />}
// //       title={null}>
// //       <div style={{ padding: "8px 0" }}>
// //         <div style={{ textAlign: "center", marginBottom: 24 }}>
// //           <div style={{
// //             width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px",
// //             background: C.blue, display: "flex", alignItems: "center", justifyContent: "center",
// //             fontSize: 22, color: "white",
// //           }}>
// //             <TeamOutlined />
// //           </div>
// //           <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
// //             Rencontrez l'équipe <span style={{ color: C.orange }}>Nomidya</span>
// //           </h2>
// //           <p style={{ color: C.textLight, fontSize: 13, margin: 0 }}>
// //             Une équipe passionnée, animée par une vision commune
// //           </p>
// //         </div>

// //         <div style={{
// //           padding: 14, background: C.bg, borderRadius: 10,
// //           border: `1px solid ${C.border}`, marginBottom: 18,
// //         }}>
// //           <p style={{ margin: 0, fontSize: 13, color: C.text, lineHeight: 1.6 }}>
// //             Notre équipe est composée d'experts chevronnés dans les domaines de SAP, de la gestion de projets, de la formation professionnelle et de la technologie.
// //           </p>
// //         </div>

// //         <Row gutter={[12, 12]}>
// //           {sections.map((s, i) => (
// //             <Col xs={24} sm={12} key={i}>
// //               <div style={{
// //                 padding: 16, borderRadius: 10, border: `1px solid ${C.border}`,
// //                 borderLeft: `3px solid ${s.color}`, background: "white", height: "100%",
// //               }}>
// //                 <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
// //                   <div style={{
// //                     width: 34, height: 34, borderRadius: 10, background: s.color,
// //                     display: "flex", alignItems: "center", justifyContent: "center",
// //                     fontSize: 16, color: "white",
// //                   }}>
// //                     {s.icon}
// //                   </div>
// //                   <span style={{ fontSize: 14, fontWeight: 700, color: C.blueDark }}>{s.title}</span>
// //                 </div>
// //                 <p style={{ margin: 0, fontSize: 12, color: C.textLight, lineHeight: 1.55 }}>{s.desc}</p>
// //               </div>
// //             </Col>
// //           ))}
// //         </Row>

// //         <div style={{
// //           marginTop: 18, padding: 16, borderRadius: 10, textAlign: "center",
// //           background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`,
// //         }}>
// //           <p style={{ margin: 0, color: "white", fontSize: 13, lineHeight: 1.6 }}>
// //             <RocketOutlined style={{ marginRight: 6 }} />
// //             Chez Nomidya, nous formons une communauté dynamique, ouverte et engagée à aider chaque apprenant à atteindre ses objectifs professionnels.
// //           </p>
// //         </div>
// //       </div>
// //     </Modal>
// //   );
// // };

// // /* ================================================================
// //    Modal — FAQ
// //    ================================================================ */
// // const FaqModal = ({ visible, onClose }) => {
// //   const faqItems = [
// //     { q: "Qu'est-ce que Nomidya ?", a: "Nomidya est une plateforme d'e-learning qui propose des MOOC professionnels. Notre plateforme vous permet de développer des compétences de haut niveau dans des domaines très demandés.", tags: ["E-learning", "MOOC"] },
// //     { q: "Qui sont les formateurs ?", a: "Nos formateurs sont des experts du secteur, possédant une riche expérience dans les domaines de SAP et de la gestion de projets.", tags: ["Experts", "SAP"] },
// //     { q: "Comment m'inscrire à un cours ?", a: "Rendez-vous sur la page du cours qui vous intéresse, cliquez sur le bouton d'inscription, créez un compte et procédez au paiement.", tags: ["Inscription", "Paiement"] },
// //     { q: "Quels modes de paiement ?", a: "Nous acceptons les paiements par carte de crédit, carte de débit et PayPal. Toutes les transactions sont sécurisées.", tags: ["Paiement", "Sécurité"] },
// //     { q: "Accès au contenu 24/7 ?", a: "Oui, vous pouvez accéder au contenu du cours à tout moment et étudier à votre propre rythme.", tags: ["Flexibilité", "24/7"] },
// //     { q: "Certificat à la fin ?", a: "Oui, à la fin de chaque cours, vous recevrez un certificat de réussite attestant de votre participation.", tags: ["Certificat", "CV"] },
// //     { q: "Puis-je poser des questions ?", a: "Oui, nous encourageons les échanges et vous fournirons un support tout au long de votre parcours.", tags: ["Support", "Interaction"] },
// //   ];

// //   return (
// //     <Modal open={visible} onCancel={onClose} footer={null} width={640}
// //       style={{ maxWidth: "95vw" }} centered
// //       closeIcon={<CloseOutlined style={{ color: C.textLight }} />}
// //       title={null}>
// //       <div style={{ padding: "8px 0" }}>
// //         <div style={{ textAlign: "center", marginBottom: 20 }}>
// //           <div style={{
// //             width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px",
// //             background: "#00875A", display: "flex", alignItems: "center", justifyContent: "center",
// //             fontSize: 22, color: "white",
// //           }}>
// //             <QuestionCircleOutlined />
// //           </div>
// //           <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
// //             Foire aux <span style={{ color: C.orange }}>Questions</span>
// //           </h2>
// //           <p style={{ color: C.textLight, fontSize: 13, margin: 0 }}>
// //             Les réponses aux questions les plus fréquentes
// //           </p>
// //         </div>

// //         <div style={{
// //           padding: "10px 14px", background: C.blueLight, borderRadius: 8,
// //           borderLeft: `3px solid ${C.blue}`, marginBottom: 16,
// //         }}>
// //           <p style={{ margin: 0, fontSize: 12, color: C.blue }}>
// //             Si vous ne trouvez pas votre réponse, contactez-nous à <strong>contact@nomidya.com</strong>
// //           </p>
// //         </div>

// //         <Collapse accordion size="small"
// //           style={{ background: "transparent", border: "none" }}
// //           expandIconPosition="end">
// //           {faqItems.map((item, i) => (
// //             <Panel
// //               key={i}
// //               header={<span style={{ fontSize: 13, fontWeight: 600, color: C.blueDark }}>{item.q}</span>}
// //               style={{
// //                 marginBottom: 8, borderRadius: 8, overflow: "hidden",
// //                 border: `1px solid ${C.border}`, background: "white",
// //               }}>
// //               <p style={{ margin: "0 0 8px", fontSize: 12, color: C.text, lineHeight: 1.6 }}>
// //                 {item.a}
// //               </p>
// //               <div>
// //                 {item.tags.map((tag, j) => (
// //                   <Tag key={j} color={C.blue} style={{ fontSize: 10, borderRadius: 8, margin: 2 }}>{tag}</Tag>
// //                 ))}
// //               </div>
// //             </Panel>
// //           ))}
// //         </Collapse>
// //       </div>
// //     </Modal>
// //   );
// // };

// // /* ================================================================
// //    Modal — À Propos
// //    ================================================================ */
// // const AboutModal = ({ visible, onClose }) => {
// //   const values = [
// //     { title: "Excellence", icon: <TrophyOutlined />, color: "#00875A" },
// //     { title: "Accessibilité", icon: <GlobalOutlined />, color: C.blue },
// //     { title: "Innovation", icon: <BulbOutlined />, color: C.orange },
// //     { title: "Engagement", icon: <HeartOutlined />, color: "#DC2626" },
// //   ];

// //   return (
// //     <Modal open={visible} onCancel={onClose} footer={null} width={720}
// //       style={{ maxWidth: "95vw" }} centered
// //       closeIcon={<CloseOutlined style={{ color: C.textLight }} />}
// //       title={null}>
// //       <div style={{ padding: "8px 0" }}>
// //         <div style={{ textAlign: "center", marginBottom: 20 }}>
// //           <div style={{
// //             width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px",
// //             background: C.orange, display: "flex", alignItems: "center", justifyContent: "center",
// //             fontSize: 22, color: "white",
// //           }}>
// //             <FileTextOutlined />
// //           </div>
// //           <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
// //             À Propos de <span style={{ color: C.orange }}>Nomidya</span>
// //           </h2>
// //           <p style={{ color: C.textLight, fontSize: 13, margin: 0 }}>
// //             Notre histoire, notre mission et nos valeurs
// //           </p>
// //         </div>

// //         <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
// //           <Col xs={24} md={12}>
// //             <div style={{
// //               padding: 16, borderRadius: 10, background: C.bg,
// //               border: `1px solid ${C.border}`, height: "100%",
// //             }}>
// //               <h4 style={{ color: C.blueDark, fontSize: 15, fontWeight: 700, margin: "0 0 8px" }}>
// //                 <HeartOutlined style={{ color: C.orange, marginRight: 6 }} /> Notre Histoire
// //               </h4>
// //               <p style={{ margin: 0, fontSize: 12, color: C.text, lineHeight: 1.65 }}>
// //                 Des consultants et gestionnaires chevronnés travaillant pour des multinationales ont voulu partager leurs connaissances avec le monde entier. Ainsi est née <strong style={{ color: C.blue }}>Nomidya</strong>, une plateforme e-learning qui révolutionne l'apprentissage en ligne avec des cours de haute qualité basés sur des expériences du monde réel.
// //               </p>
// //             </div>
// //           </Col>
// //           <Col xs={24} md={12}>
// //             <div style={{
// //               padding: 16, borderRadius: 10, height: "100%",
// //               background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`,
// //             }}>
// //               <h4 style={{ color: "white", fontSize: 15, fontWeight: 700, margin: "0 0 8px" }}>
// //                 <GlobalOutlined style={{ marginRight: 6 }} /> Notre Évolution
// //               </h4>
// //               <p style={{ margin: 0, fontSize: 12, color: "rgba(255,255,255,0.85)", lineHeight: 1.65 }}>
// //                 Aujourd'hui, Nomidya est devenue un leader mondial avec des participants dans plus de <strong style={{ color: C.orangeLight }}>175 pays</strong>. Grâce à notre approche flexible et notre enseignement axé sur la pratique, les apprenants progressent dans leur carrière et deviennent des professionnels de premier ordre.
// //               </p>
// //             </div>
// //           </Col>
// //         </Row>

// //         <div style={{
// //           padding: 16, borderRadius: 10, marginBottom: 16,
// //           background: C.orangeBg, borderLeft: `3px solid ${C.orange}`,
// //         }}>
// //           <h4 style={{ color: C.blueDark, fontSize: 14, fontWeight: 700, margin: "0 0 6px" }}>
// //             <RocketOutlined style={{ color: C.orange, marginRight: 6 }} /> Notre Mission
// //           </h4>
// //           <p style={{ margin: 0, fontSize: 12, color: C.text, lineHeight: 1.6 }}>
// //             Fournir une expérience d'apprentissage en ligne de qualité supérieure, offrant l'accès à des cours de pointe dans les domaines de SAP et de la gestion de projets. Inspirer, former et accompagner chaque individu dans son parcours.
// //           </p>
// //         </div>

// //         <h4 style={{ color: C.blueDark, fontSize: 14, fontWeight: 700, margin: "0 0 10px", textAlign: "center" }}>
// //           <StarOutlined style={{ color: C.orange, marginRight: 6 }} /> Nos Valeurs
// //         </h4>
// //         <Row gutter={[10, 10]}>
// //           {values.map((v, i) => (
// //             <Col xs={12} sm={6} key={i}>
// //               <div style={{
// //                 textAlign: "center", padding: "14px 10px", borderRadius: 10,
// //                 border: `1px solid ${C.border}`, borderTop: `3px solid ${v.color}`,
// //                 background: "white",
// //               }}>
// //                 <div style={{ fontSize: 22, color: v.color, marginBottom: 6 }}>{v.icon}</div>
// //                 <span style={{ fontSize: 11, fontWeight: 700, color: C.blueDark }}>{v.title}</span>
// //               </div>
// //             </Col>
// //           ))}
// //         </Row>

// //         <div style={{
// //           marginTop: 16, padding: 14, borderRadius: 10, textAlign: "center",
// //           background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`,
// //         }}>
// //           <p style={{ margin: 0, color: "rgba(255,255,255,0.9)", fontSize: 12, lineHeight: 1.6 }}>
// //             <CheckCircleOutlined style={{ marginRight: 6, color: C.orangeLight }} />
// //             Ensemble, nous construisons un avenir où l'apprentissage transforme des vies et où les compétences ouvrent des portes vers de nouvelles opportunités.
// //           </p>
// //         </div>
// //       </div>
// //     </Modal>
// //   );
// // };

// // /* ================================================================
// //    PAGE D'ACCUEIL
// //    ================================================================ */
// // const HomePage = () => {
// //   const [teamVisible, setTeamVisible] = useState(false);
// //   const [faqVisible, setFaqVisible] = useState(false);
// //   const [aboutVisible, setAboutVisible] = useState(false);

// //   const cards = [
// //     { icon: <TeamOutlined />, title: "Notre Équipe", desc: "Rencontrez les experts qui rendent l'apprentissage possible", btn: "Découvrir", color: C.blue, onClick: () => setTeamVisible(true) },
// //     { icon: <QuestionCircleOutlined />, title: "FAQ", desc: "Trouvez rapidement les réponses à vos questions", btn: "Consulter", color: "#00875A", onClick: () => setFaqVisible(true) },
// //     { icon: <FileTextOutlined />, title: "À Propos", desc: "Découvrez notre histoire, mission et valeurs", btn: "En savoir plus", color: C.orange, onClick: () => setAboutVisible(true) },
// //   ];

// //   return (
// //     <Layout style={{ minHeight: "100vh", background: C.white }}>

// //       {/* ============ Section 1: Découvrez Nomidya ============ */}
// //       <div style={{
// //         padding: "40px 24px 32px", background: C.white,
// //         borderBottom: `1px solid ${C.border}`,
// //       }}>
// //         <div style={{ textAlign: "center", marginBottom: 24 }}>
// //           <span style={{
// //             fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
// //             textTransform: "uppercase", display: "inline-block",
// //             padding: "3px 12px", borderRadius: 12, background: C.orangeBg, marginBottom: 8,
// //           }}>
// //             Bienvenue
// //           </span>
// //           <h2 style={{
// //             color: C.blueDark, fontSize: 28, fontWeight: 800, margin: "8px 0 6px",
// //             fontFamily: "'Outfit', -apple-system, sans-serif",
// //           }}>
// //             Découvrez <span style={{ color: C.orange }}>Nomidya</span>
// //           </h2>
// //           <p style={{ fontSize: 14, color: C.textLight, margin: 0 }}>
// //             Notre plateforme, notre mission et notre équipe
// //           </p>
// //         </div>

// //         {/* 3 cartes — ouvrent des modals */}
// //         <Row gutter={[20, 20]} justify="center" style={{ maxWidth: 1200, margin: "0 auto" }}>
// //           {cards.map((item, i) => (
// //             <Col xs={24} sm={8} key={i}>
// //               <div
// //                 onClick={item.onClick}
// //                 style={{
// //                   textAlign: "center", borderRadius: 12, padding: "24px 18px",
// //                   background: C.white, border: `1px solid ${C.border}`,
// //                   transition: "all 0.3s ease", cursor: "pointer",
// //                   boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
// //                 }}
// //                 onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,84,166,0.12)"; e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.borderColor = item.color; }}
// //                 onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.borderColor = C.border; }}
// //               >
// //                 <div style={{
// //                   width: 44, height: 44, borderRadius: 12, margin: "0 auto 12px",
// //                   background: item.color, display: "flex", alignItems: "center", justifyContent: "center",
// //                   fontSize: 20, color: "white",
// //                 }}>
// //                   {item.icon}
// //                 </div>
// //                 <div style={{ fontSize: 16, fontWeight: 700, color: C.blueDark, marginBottom: 6 }}>
// //                   {item.title}
// //                 </div>
// //                 <div style={{ fontSize: 13, color: C.textLight, lineHeight: 1.5, marginBottom: 14, minHeight: 40 }}>
// //                   {item.desc}
// //                 </div>
// //                 <span style={{
// //                   display: "inline-block", padding: "6px 20px", borderRadius: 20,
// //                   background: item.color, color: "white", fontWeight: 600, fontSize: 12,
// //                 }}>
// //                   {item.btn}
// //                 </span>
// //               </div>
// //             </Col>
// //           ))}
// //         </Row>

// //         <div style={{ textAlign: "center", marginTop: 20 }}>
// //           <Space size="large" wrap>
// //             {[
// //               ["mission-values", "Mission & Valeurs", () => setAboutVisible(true)],
// //               ["legal-notices", "Mentions Légales", null],
// //               ["privacy-policy", "Confidentialité", null],
// //             ].map(([key, label, onClick]) => (
// //               onClick ? (
// //                 <span key={key} onClick={onClick}
// //                   style={{ color: C.blue, fontSize: 12, fontWeight: 500, cursor: "pointer" }}>
// //                   {label}
// //                 </span>
// //               ) : (
// //                 <Link key={key} to={`/${key}`}
// //                   style={{ color: C.blue, fontSize: 12, fontWeight: 500, textDecoration: "none" }}>
// //                   {label}
// //                 </Link>
// //               )
// //             ))}
// //           </Space>
// //         </div>
// //       </div>

// //       <Content style={{ backgroundColor: C.white, padding: 0 }}>
// //         <DedicatedAccessSection />
// //         <div style={{ padding: "40px 20px" }}>
// //           <CoursesByCategory />
// //         </div>
// //         <div>
// //           <NewsSection />
// //         </div>

// //         {/* ============ Statistiques ============ */}
// //         <div style={{
// //           background: `linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%)`,
// //           padding: "48px 24px",
// //         }}>
// //           <div style={{ maxWidth: 1200, margin: "0 auto" }}>
// //             <div style={{ textAlign: "center", marginBottom: 32 }}>
// //               <span style={{
// //                 fontSize: 11, fontWeight: 700, color: C.orangeLight, letterSpacing: 1.5,
// //                 textTransform: "uppercase", display: "inline-block",
// //                 padding: "3px 12px", borderRadius: 12, background: "rgba(232,134,12,0.15)", marginBottom: 8,
// //               }}>
// //                 En chiffres
// //               </span>
// //               <h2 style={{
// //                 color: "white", fontSize: 28, fontWeight: 800, margin: "8px 0 6px",
// //                 fontFamily: "'Outfit', sans-serif",
// //               }}>
// //                 Pourquoi choisir <span style={{ color: C.orangeLight }}>Nomidya</span> ?
// //               </h2>
// //               <p style={{ fontSize: 14, color: "rgba(255,255,255,0.6)", margin: 0 }}>
// //                 Des chiffres qui parlent de notre excellence
// //               </p>
// //             </div>
// //             <Row gutter={[20, 20]}>
// //               {[
// //                 { title: "Apprenants actifs", value: "1 500+", icon: <UserOutlined /> },
// //                 { title: "Cours disponibles", value: "200+", icon: <ReadOutlined /> },
// //                 { title: "Instructeurs certifiés", value: "50+", icon: <TeamOutlined /> },
// //                 { title: "Taux de satisfaction", value: "98%", icon: <LineChartOutlined /> },
// //               ].map((stat, i) => (
// //                 <Col xs={12} sm={6} key={i}>
// //                   <div style={{
// //                     textAlign: "center", padding: "24px 16px", borderRadius: 12,
// //                     background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)",
// //                     transition: "all 0.3s ease",
// //                   }}
// //                     onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.14)"; e.currentTarget.style.transform = "translateY(-3px)"; }}
// //                     onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; e.currentTarget.style.transform = "translateY(0)"; }}
// //                   >
// //                     <div style={{
// //                       width: 44, height: 44, borderRadius: 12, margin: "0 auto 10px",
// //                       background: C.orangeLight, display: "flex", alignItems: "center", justifyContent: "center",
// //                       fontSize: 20, color: "white",
// //                     }}>
// //                       {stat.icon}
// //                     </div>
// //                     <div style={{ fontSize: 26, fontWeight: 800, color: "white", marginBottom: 4 }}>
// //                       {stat.value}
// //                     </div>
// //                     <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>
// //                       {stat.title}
// //                     </div>
// //                   </div>
// //                 </Col>
// //               ))}
// //             </Row>
// //           </div>
// //         </div>
// //       </Content>

// //       {/* ============ Footer ============ */}
// //       <Footer style={{
// //         textAlign: "center", backgroundColor: C.blueDark,
// //         padding: "24px 20px", borderTop: "none",
// //       }}>
// //         <img src="/img/nomidya.png" alt="Nomidya" style={{ height: 36, marginBottom: 8, opacity: 0.9 }}
// //           onError={e => { e.target.style.display = 'none'; }} />
// //         <p style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", margin: 0 }}>
// //           © 2026 Nomidya — La Carrière. Tous droits réservés.
// //         </p>
// //       </Footer>

// //       {/* ============ MODALS ============ */}
// //       <TeamModal visible={teamVisible} onClose={() => setTeamVisible(false)} />
// //       <FaqModal visible={faqVisible} onClose={() => setFaqVisible(false)} />
// //       <AboutModal visible={aboutVisible} onClose={() => setAboutVisible(false)} />
// //     </Layout>
// //   );
// // };

// // export default HomePage;

// import React, { useState } from "react";
// import { Layout, Row, Col, Modal, Collapse, Tag, Space } from "antd";
// import {
//   UserOutlined, ReadOutlined, LineChartOutlined,
//   QuestionCircleOutlined, TeamOutlined, FileTextOutlined,
//   CloseOutlined, CrownOutlined, BookOutlined, ToolOutlined,
//   CustomerServiceOutlined, RocketOutlined, HeartOutlined,
//   GlobalOutlined, BulbOutlined, TrophyOutlined, StarOutlined,
//   CheckCircleOutlined, ArrowRightOutlined, PlayCircleOutlined,
//   SafetyCertificateOutlined, ClockCircleOutlined, FireOutlined
// } from "@ant-design/icons";
// import { Link, useNavigate } from "react-router-dom";
// import DedicatedAccessSection from "./admin_and_user/DedicatedAccessSection";
// import CoursesByCategory from "./admin_and_user/CoursesByCategory";
// import NewsSection from "./admin_and_user/NewsSection";

// const { Content, Footer } = Layout;
// const { Panel } = Collapse;

// const C = {
//   blue: "#0054A6",
//   blueDark: "#003B75",
//   blueDeep: "#002147",
//   blueLight: "#e8f1fb",
//   orange: "#E8860C",
//   orangeLight: "#FF8C00",
//   orangeDark: "#C46F0A",
//   orangeBg: "#fff8f0",
//   white: "#ffffff",
//   bg: "#f7f8fa",
//   text: "#1a1a1a",
//   textLight: "#6b7280",
//   border: "#e5e7eb",
// };

// /* ==================== MODALS (gardés tels quels) ==================== */
// const TeamModal = ({ visible, onClose }) => {
//   const sections = [
//     { title: "Nos Fondateurs", icon: <CrownOutlined />, color: C.orange,
//       desc: "D'anciens consultants et gestionnaires dans des multinationales, qui ont fondé Nomidya avec la mission de partager leurs connaissances." },
//     { title: "Nos Formateurs", icon: <BookOutlined />, color: "#00875A",
//       desc: "Soigneusement sélectionnés, ce sont des experts du secteur, dotés d'une vaste expérience pratique." },
//     { title: "Équipe Technique", icon: <ToolOutlined />, color: C.blue,
//       desc: "Travaille sans relâche pour maintenir notre plateforme à la pointe de la technologie." },
//     { title: "Support Apprenants", icon: <CustomerServiceOutlined />, color: "#DC2626",
//       desc: "Là pour guider, accompagner et répondre aux questions de nos apprenants." },
//   ];

//   return (
//     <Modal open={visible} onCancel={onClose} footer={null} width={720} centered closeIcon={<CloseOutlined />} title={null}>
//       <div style={{ padding: "8px 0" }}>
//         <div style={{ textAlign: "center", marginBottom: 24 }}>
//           <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px", background: C.blue, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "white" }}>
//             <TeamOutlined />
//           </div>
//           <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
//             L'équipe <span style={{ color: C.orange }}>Nomidya</span>
//           </h2>
//         </div>
//         <Row gutter={[12, 12]}>
//           {sections.map((s, i) => (
//             <Col xs={24} sm={12} key={i}>
//               <div style={{ padding: 16, borderRadius: 10, border: `1px solid ${C.border}`, borderLeft: `3px solid ${s.color}`, background: "white", height: "100%" }}>
//                 <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
//                   <div style={{ width: 34, height: 34, borderRadius: 10, background: s.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, color: "white" }}>{s.icon}</div>
//                   <span style={{ fontSize: 14, fontWeight: 700, color: C.blueDark }}>{s.title}</span>
//                 </div>
//                 <p style={{ margin: 0, fontSize: 12, color: C.textLight, lineHeight: 1.55 }}>{s.desc}</p>
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </div>
//     </Modal>
//   );
// };

// const FaqModal = ({ visible, onClose }) => {
//   const faqItems = [
//     { q: "Qu'est-ce que Nomidya ?", a: "Nomidya est une plateforme d'e-learning qui propose des MOOC professionnels.", tags: ["E-learning", "MOOC"] },
//     { q: "Qui sont les formateurs ?", a: "Nos formateurs sont des experts du secteur SAP et de la gestion de projets.", tags: ["Experts", "SAP"] },
//     { q: "Comment m'inscrire ?", a: "Rendez-vous sur la page du cours, créez un compte et procédez au paiement.", tags: ["Inscription"] },
//     { q: "Modes de paiement ?", a: "Carte de crédit, débit, PayPal. Toutes transactions sécurisées.", tags: ["Paiement"] },
//     { q: "Accès 24/7 ?", a: "Oui, accès au contenu à tout moment.", tags: ["Flexibilité"] },
//     { q: "Certificat ?", a: "Oui, certificat de réussite à la fin de chaque cours.", tags: ["Certificat"] },
//   ];

//   return (
//     <Modal open={visible} onCancel={onClose} footer={null} width={640} centered closeIcon={<CloseOutlined />} title={null}>
//       <div style={{ padding: "8px 0" }}>
//         <div style={{ textAlign: "center", marginBottom: 20 }}>
//           <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px", background: "#00875A", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "white" }}>
//             <QuestionCircleOutlined />
//           </div>
//           <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
//             Foire aux <span style={{ color: C.orange }}>Questions</span>
//           </h2>
//         </div>
//         <Collapse accordion size="small" style={{ background: "transparent", border: "none" }}>
//           {faqItems.map((item, i) => (
//             <Panel key={i} header={<span style={{ fontSize: 13, fontWeight: 600, color: C.blueDark }}>{item.q}</span>}
//               style={{ marginBottom: 8, borderRadius: 8, border: `1px solid ${C.border}`, background: "white" }}>
//               <p style={{ margin: "0 0 8px", fontSize: 12, color: C.text, lineHeight: 1.6 }}>{item.a}</p>
//               <div>{item.tags.map((tag, j) => <Tag key={j} color={C.blue} style={{ fontSize: 10, margin: 2 }}>{tag}</Tag>)}</div>
//             </Panel>
//           ))}
//         </Collapse>
//       </div>
//     </Modal>
//   );
// };

// const AboutModal = ({ visible, onClose }) => (
//   <Modal open={visible} onCancel={onClose} footer={null} width={720} centered closeIcon={<CloseOutlined />} title={null}>
//     <div style={{ padding: "8px 0" }}>
//       <div style={{ textAlign: "center", marginBottom: 20 }}>
//         <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px", background: C.orange, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "white" }}>
//           <FileTextOutlined />
//         </div>
//         <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
//           À Propos de <span style={{ color: C.orange }}>Nomidya</span>
//         </h2>
//       </div>
//       <p style={{ fontSize: 13, color: C.text, lineHeight: 1.7, textAlign: "center", padding: "0 20px" }}>
//         Nomidya est une plateforme e-learning fondée par d'anciens consultants SAP. Notre mission : démocratiser
//         l'apprentissage SAP de qualité avec des formations pratiques basées sur des cas réels.
//       </p>
//     </div>
//   </Modal>
// );

// /* ==================== HOMEPAGE PRO ==================== */
// const HomePage = () => {
//   const navigate = useNavigate();
//   const [teamVisible, setTeamVisible] = useState(false);
//   const [faqVisible, setFaqVisible] = useState(false);
//   const [aboutVisible, setAboutVisible] = useState(false);

//   return (
//     <Layout style={{ minHeight: "100vh", background: C.white }}>
//       <style>{`
//         @keyframes float-bg { 0%, 100% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-20px) rotate(2deg); } }
//         @keyframes fade-up { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes pulse-orange { 0%, 100% { box-shadow: 0 0 0 0 rgba(232,134,12,0.4); } 50% { box-shadow: 0 0 0 15px rgba(232,134,12,0); } }
//         .hero-cta-primary { animation: pulse-orange 2s infinite; }
//         .feature-card { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
//         .feature-card:hover { transform: translateY(-8px); box-shadow: 0 20px 40px rgba(0,84,166,0.15); }
//         .stat-pill { transition: all 0.3s; }
//         .stat-pill:hover { transform: translateY(-4px); }
//       `}</style>

//       <Content style={{ background: C.white, padding: 0 }}>

//         {/* ============ 1. HERO IMPACT ============ */}
//         <div style={{
//           background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%)`,
//           padding: "80px 24px 60px",
//           color: "white",
//           position: "relative",
//           overflow: "hidden",
//         }}>
//           {/* Décorations animées */}
//           <div style={{
//             position: "absolute", top: -100, right: -100, width: 400, height: 400,
//             background: `radial-gradient(circle, ${C.orange}33 0%, transparent 70%)`,
//             borderRadius: "50%", animation: "float-bg 8s ease-in-out infinite",
//           }} />
//           <div style={{
//             position: "absolute", bottom: -150, left: -50, width: 300, height: 300,
//             background: `radial-gradient(circle, ${C.blue}66 0%, transparent 70%)`,
//             borderRadius: "50%", animation: "float-bg 10s ease-in-out infinite reverse",
//           }} />

//           <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1, animation: "fade-up 0.8s ease-out" }}>
//             <Row gutter={[40, 40]} align="middle">
//               <Col xs={24} md={14}>
//                 {/* Badge top */}
//                 <div style={{
//                   display: "inline-flex", alignItems: "center", gap: 8,
//                   background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                   padding: "8px 18px", borderRadius: 30, fontSize: 12, fontWeight: 700,
//                   letterSpacing: 1.2, marginBottom: 24, boxShadow: `0 4px 12px ${C.orange}66`,
//                 }}>
//                   <FireOutlined /> PLATEFORME N°1 EN FORMATION SAP
//                 </div>

//                 {/* Titre principal */}
//                 <h1 style={{
//                   fontSize: 52, fontWeight: 900, lineHeight: 1.1, margin: "0 0 20px",
//                   letterSpacing: -1, textShadow: "0 2px 10px rgba(0,0,0,0.2)",
//                 }}>
//                   Devenez expert <span style={{
//                     background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                     WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
//                   }}>SAP S/4 HANA</span> en quelques mois
//                 </h1>

//                 {/* Sous-titre */}
//                 <p style={{
//                   fontSize: 17, opacity: 0.9, lineHeight: 1.7, marginBottom: 32, maxWidth: 540,
//                 }}>
//                   Plateforme e-learning premium avec accès SAP dédiés, formateurs experts
//                   et certifications reconnues. Lancez votre carrière SAP dès aujourd'hui.
//                 </p>

//                 {/* CTA Buttons */}
//                 <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 32 }}>
//                   <button
//                     onClick={() => navigate('/courses')}
//                     className="hero-cta-primary"
//                     style={{
//                       padding: "16px 32px", borderRadius: 12, border: "none",
//                       background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                       color: "white", fontSize: 15, fontWeight: 700, cursor: "pointer",
//                       display: "flex", alignItems: "center", gap: 10,
//                       boxShadow: `0 8px 24px ${C.orange}66`, transition: "all 0.3s",
//                     }}
//                     onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
//                     onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
//                   >
//                     <BookOutlined /> Explorer les cours <ArrowRightOutlined />
//                   </button>

//                   <button
//                     onClick={() => navigate('/sap-access')}
//                     style={{
//                       padding: "16px 32px", borderRadius: 12,
//                       border: "2px solid rgba(255,255,255,0.3)",
//                       background: "rgba(255,255,255,0.1)", color: "white",
//                       fontSize: 15, fontWeight: 600, cursor: "pointer",
//                       display: "flex", alignItems: "center", gap: 10,
//                       backdropFilter: "blur(10px)", transition: "all 0.3s",
//                     }}
//                     onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.2)"; }}
//                     onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.1)"; }}
//                   >
//                     <RocketOutlined /> Accès SAP S/4 HANA
//                   </button>
//                 </div>

//                 {/* Stats inline */}
//                 <div style={{ display: "flex", gap: 32, flexWrap: "wrap", paddingTop: 20, borderTop: "1px solid rgba(255,255,255,0.15)" }}>
//                   {[
//                     { value: "1500+", label: "Apprenants" },
//                     { value: "200+", label: "Cours" },
//                     { value: "175", label: "Pays" },
//                     { value: "98%", label: "Satisfaction" },
//                   ].map((s, i) => (
//                     <div key={i} className="stat-pill">
//                       <div style={{ fontSize: 24, fontWeight: 800, color: C.orangeLight }}>{s.value}</div>
//                       <div style={{ fontSize: 11, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}>{s.label}</div>
//                     </div>
//                   ))}
//                 </div>
//               </Col>

//               {/* Image illustration côté droit */}
//               <Col xs={24} md={10}>
//                 <div style={{
//                   position: "relative", padding: "30px",
//                 }}>
//                   <div style={{
//                     background: "rgba(255,255,255,0.1)", backdropFilter: "blur(20px)",
//                     border: "1px solid rgba(255,255,255,0.2)", borderRadius: 24,
//                     padding: 40, textAlign: "center",
//                     boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
//                   }}>
//                     <div style={{
//                       width: 120, height: 120, margin: "0 auto 24px",
//                       background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                       borderRadius: 24, display: "flex", alignItems: "center", justifyContent: "center",
//                       fontSize: 60, boxShadow: `0 12px 40px ${C.orange}66`,
//                     }}>
//                       🎓
//                     </div>
//                     <h3 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 12px" }}>Apprentissage Premium</h3>
//                     <p style={{ fontSize: 14, opacity: 0.85, margin: "0 0 20px", lineHeight: 1.6 }}>
//                       Accès illimité, certificats reconnus, support 7j/7
//                     </p>
//                     <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
//                       {["✓ HD Vidéos", "✓ Quiz interactifs", "✓ Certificats"].map((f, i) => (
//                         <div key={i} style={{
//                           fontSize: 11, padding: "6px 12px", borderRadius: 20,
//                           background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.2)",
//                         }}>{f}</div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </Col>
//             </Row>
//           </div>
//         </div>

//         {/* ============ 2. ACCÈS SAP DÉDIÉS ============ */}
//         <DedicatedAccessSection />

//         {/* ============ 3. CATALOGUE COURS ============ */}
//         <div style={{ padding: "60px 20px", background: C.bg }}>
//           <CoursesByCategory />
//         </div>

//         {/* ============ 4. POURQUOI NOMIDYA ? ============ */}
//         <div style={{ padding: "80px 24px", background: C.white }}>
//           <div style={{ maxWidth: 1200, margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: 48 }}>
//               <span style={{
//                 fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
//                 textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
//                 background: C.orangeBg, display: "inline-block", marginBottom: 12,
//               }}>
//                 Pourquoi nous choisir
//               </span>
//               <h2 style={{ fontSize: 36, fontWeight: 800, color: C.blueDark, margin: "8px 0 12px" }}>
//                 Une plateforme conçue pour <span style={{ color: C.orange }}>votre réussite</span>
//               </h2>
//               <p style={{ fontSize: 16, color: C.textLight, maxWidth: 600, margin: "0 auto" }}>
//                 Tout ce dont vous avez besoin pour devenir un expert SAP recherché sur le marché.
//               </p>
//             </div>

//             <Row gutter={[24, 24]}>
//               {[
//                 { icon: <SafetyCertificateOutlined />, title: "Certificats reconnus", desc: "Obtenez des certifications valorisées par les recruteurs SAP du monde entier.", color: C.blue },
//                 { icon: <RocketOutlined />, title: "Accès SAP réels", desc: "Pratiquez sur de vrais systèmes SAP S/4 HANA dédiés, pas de simulations.", color: C.orange },
//                 { icon: <TeamOutlined />, title: "Formateurs experts", desc: "Apprenez avec d'anciens consultants ayant 10+ ans d'expérience terrain.", color: "#00875A" },
//                 { icon: <ClockCircleOutlined />, title: "Apprentissage flexible", desc: "Étudiez à votre rythme, 24/7, depuis n'importe quel appareil.", color: "#7C3AED" },
//               ].map((f, i) => (
//                 <Col xs={24} sm={12} lg={6} key={i}>
//                   <div className="feature-card" style={{
//                     padding: "32px 24px", borderRadius: 16, background: "white",
//                     border: `1px solid ${C.border}`, height: "100%", textAlign: "center",
//                     boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//                   }}>
//                     <div style={{
//                       width: 64, height: 64, borderRadius: 16, margin: "0 auto 20px",
//                       background: `${f.color}15`, color: f.color,
//                       display: "flex", alignItems: "center", justifyContent: "center",
//                       fontSize: 28, border: `2px solid ${f.color}33`,
//                     }}>
//                       {f.icon}
//                     </div>
//                     <h3 style={{ fontSize: 17, fontWeight: 700, color: C.blueDark, margin: "0 0 10px" }}>
//                       {f.title}
//                     </h3>
//                     <p style={{ fontSize: 13, color: C.textLight, lineHeight: 1.6, margin: 0 }}>
//                       {f.desc}
//                     </p>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         </div>

//         {/* ============ 5. NEWS ============ */}
//         <NewsSection />

//         {/* ============ 6. STATISTIQUES (Bleu) ============ */}
//         <div style={{
//           background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 100%)`,
//           padding: "60px 24px", position: "relative", overflow: "hidden",
//         }}>
//           <div style={{
//             position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
//             backgroundImage: `radial-gradient(circle at 80% 30%, ${C.orange}22 0%, transparent 50%)`,
//             pointerEvents: "none",
//           }} />
//           <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>
//             <div style={{ textAlign: "center", marginBottom: 40 }}>
//               <h2 style={{ color: "white", fontSize: 32, fontWeight: 800, margin: "0 0 12px" }}>
//                 Rejoignez plus de <span style={{ color: C.orangeLight }}>1 500 apprenants</span>
//               </h2>
//             </div>
//             <Row gutter={[20, 20]}>
//               {[
//                 { title: "Apprenants actifs", value: "1 500+", icon: <UserOutlined /> },
//                 { title: "Cours disponibles", value: "200+", icon: <ReadOutlined /> },
//                 { title: "Instructeurs experts", value: "50+", icon: <TeamOutlined /> },
//                 { title: "Taux de satisfaction", value: "98%", icon: <LineChartOutlined /> },
//               ].map((stat, i) => (
//                 <Col xs={12} sm={6} key={i}>
//                   <div style={{
//                     textAlign: "center", padding: "28px 16px", borderRadius: 16,
//                     background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)",
//                     transition: "all 0.3s",
//                   }}
//                     onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.14)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
//                     onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; e.currentTarget.style.transform = "translateY(0)"; }}
//                   >
//                     <div style={{
//                       width: 52, height: 52, borderRadius: 14, margin: "0 auto 12px",
//                       background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//                       display: "flex", alignItems: "center", justifyContent: "center",
//                       fontSize: 22, color: "white", boxShadow: `0 6px 20px ${C.orange}66`,
//                     }}>{stat.icon}</div>
//                     <div style={{ fontSize: 30, fontWeight: 800, color: "white", marginBottom: 4 }}>{stat.value}</div>
//                     <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: 1 }}>{stat.title}</div>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         </div>

//         {/* ============ 7. DÉCOUVREZ NOMIDYA (Équipe / FAQ / About) ============ */}
//         <div style={{ padding: "60px 24px", background: C.bg }}>
//           <div style={{ maxWidth: 1200, margin: "0 auto" }}>
//             <div style={{ textAlign: "center", marginBottom: 40 }}>
//               <span style={{
//                 fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
//                 textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
//                 background: C.orangeBg, display: "inline-block", marginBottom: 12,
//               }}>
//                 À découvrir
//               </span>
//               <h2 style={{ fontSize: 32, fontWeight: 800, color: C.blueDark, margin: "8px 0 6px" }}>
//                 Découvrez <span style={{ color: C.orange }}>Nomidya</span>
//               </h2>
//               <p style={{ fontSize: 14, color: C.textLight, margin: 0 }}>
//                 Notre plateforme, notre mission, notre équipe
//               </p>
//             </div>

//             <Row gutter={[20, 20]} justify="center">
//               {[
//                 { icon: <TeamOutlined />, title: "Notre Équipe", desc: "Rencontrez les experts qui rendent l'apprentissage possible", btn: "Découvrir", color: C.blue, onClick: () => setTeamVisible(true) },
//                 { icon: <QuestionCircleOutlined />, title: "FAQ", desc: "Trouvez rapidement les réponses à vos questions", btn: "Consulter", color: "#00875A", onClick: () => setFaqVisible(true) },
//                 { icon: <FileTextOutlined />, title: "À Propos", desc: "Notre histoire, mission et valeurs", btn: "En savoir plus", color: C.orange, onClick: () => setAboutVisible(true) },
//               ].map((item, i) => (
//                 <Col xs={24} sm={8} key={i}>
//                   <div className="feature-card"
//                     onClick={item.onClick}
//                     style={{
//                       textAlign: "center", borderRadius: 16, padding: "32px 24px",
//                       background: "white", border: `1px solid ${C.border}`,
//                       cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
//                     }}
//                   >
//                     <div style={{
//                       width: 56, height: 56, borderRadius: 14, margin: "0 auto 16px",
//                       background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
//                       display: "flex", alignItems: "center", justifyContent: "center",
//                       fontSize: 24, color: "white", boxShadow: `0 6px 20px ${item.color}44`,
//                     }}>{item.icon}</div>
//                     <h3 style={{ fontSize: 18, fontWeight: 700, color: C.blueDark, margin: "0 0 8px" }}>{item.title}</h3>
//                     <p style={{ fontSize: 13, color: C.textLight, lineHeight: 1.6, marginBottom: 16, minHeight: 40 }}>{item.desc}</p>
//                     <span style={{
//                       display: "inline-flex", alignItems: "center", gap: 6,
//                       padding: "8px 22px", borderRadius: 30, background: item.color,
//                       color: "white", fontWeight: 600, fontSize: 13,
//                     }}>
//                       {item.btn} <ArrowRightOutlined />
//                     </span>
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         </div>

//         {/* ============ 8. CTA FINAL ============ */}
//         <div style={{
//           background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//           padding: "60px 24px", textAlign: "center", color: "white",
//           position: "relative", overflow: "hidden",
//         }}>
//           <div style={{
//             position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
//             backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255,255,255,0.15) 0%, transparent 50%)`,
//             pointerEvents: "none",
//           }} />
//           <div style={{ position: "relative", zIndex: 1, maxWidth: 700, margin: "0 auto" }}>
//             <h2 style={{ fontSize: 36, fontWeight: 800, margin: "0 0 16px", textShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
//               Prêt à transformer votre carrière ?
//             </h2>
//             <p style={{ fontSize: 17, opacity: 0.95, marginBottom: 32, maxWidth: 540, margin: "0 auto 32px" }}>
//               Rejoignez la communauté Nomidya et commencez votre parcours SAP dès aujourd'hui.
//             </p>
//             <Space size="middle" wrap style={{ justifyContent: "center" }}>
//               <button
//                 onClick={() => navigate('/register')}
//                 style={{
//                   padding: "16px 36px", borderRadius: 12, border: "none",
//                   background: "white", color: C.orange, fontSize: 15, fontWeight: 700,
//                   cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 10,
//                   boxShadow: "0 8px 24px rgba(0,0,0,0.2)", transition: "all 0.3s",
//                 }}
//                 onMouseEnter={e => e.currentTarget.style.transform = "translateY(-3px)"}
//                 onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
//               >
//                 <RocketOutlined /> Créer un compte gratuit
//               </button>
//               <button
//                 onClick={() => navigate('/courses')}
//                 style={{
//                   padding: "16px 36px", borderRadius: 12,
//                   border: "2px solid rgba(255,255,255,0.5)",
//                   background: "transparent", color: "white",
//                   fontSize: 15, fontWeight: 600, cursor: "pointer",
//                   display: "inline-flex", alignItems: "center", gap: 10,
//                 }}
//               >
//                 <PlayCircleOutlined /> Voir les cours
//               </button>
//             </Space>
//           </div>
//         </div>
//       </Content>

//       {/* Footer */}
//       <Footer style={{ textAlign: "center", background: C.blueDeep, padding: "32px 20px" }}>
//         <img src="/img/nomidya.png" alt="Nomidya" style={{ height: 36, marginBottom: 12, opacity: 0.9 }}
//           onError={e => { e.target.style.display = 'none'; }} />
//         <p style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", margin: 0 }}>
//           © 2026 Nomidya — La Carrière. Tous droits réservés.
//         </p>
//       </Footer>

//       <TeamModal visible={teamVisible} onClose={() => setTeamVisible(false)} />
//       <FaqModal visible={faqVisible} onClose={() => setFaqVisible(false)} />
//       <AboutModal visible={aboutVisible} onClose={() => setAboutVisible(false)} />
//     </Layout>
//   );
// };

// export default HomePage;
import React, { useState, useEffect, useRef } from "react";
import { Layout, Row, Col, Modal, Collapse, Tag, Space, message } from "antd";
import {
  UserOutlined, ReadOutlined, LineChartOutlined,
  QuestionCircleOutlined, TeamOutlined, FileTextOutlined,
  CloseOutlined, CrownOutlined, BookOutlined, ToolOutlined,
  CustomerServiceOutlined, RocketOutlined, HeartOutlined,
  GlobalOutlined, BulbOutlined, TrophyOutlined, StarOutlined,
  CheckCircleOutlined, ArrowRightOutlined, PlayCircleOutlined,
  SafetyCertificateOutlined, ClockCircleOutlined, FireOutlined,
  VideoCameraOutlined, MailOutlined, SendOutlined,
  ThunderboltOutlined, AppstoreOutlined, DollarOutlined,
  CalendarOutlined, RightOutlined, DownOutlined,
  TeamOutlined as PeopleOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DedicatedAccessSection from "./admin_and_user/DedicatedAccessSection";
import CoursesByCategory from "./admin_and_user/CoursesByCategory";
import NewsSection from "./admin_and_user/NewsSection";
import liveTrainingService from "../services/liveTraining.service";
import courseService from "../services/course.service";
import publicCourseService from "../services/publicCourseService";
import dayjs from "dayjs";

const { Content, Footer } = Layout;
const { Panel } = Collapse;

const C = {
  blue: "#0054A6",
  blueDark: "#003B75",
  blueDeep: "#002147",
  blueLight: "#e8f1fb",
  orange: "#E8860C",
  orangeLight: "#FF8C00",
  orangeDark: "#C46F0A",
  orangeBg: "#fff8f0",
  white: "#ffffff",
  bg: "#f7f8fa",
  text: "#1a1a1a",
  textLight: "#6b7280",
  border: "#e5e7eb",
  green: "#00875A",
};

/* ============ Hook : Animation au scroll ============ */
const useScrollAnimation = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach((el) => observer.observe(el));

    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);
};

/* ============ Hook : Compteur animé ============ */
const useCounter = (end, duration = 2000, isVisible = false) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible || !end) return;
    const target = parseInt(String(end).replace(/\D/g, ''));
    if (!target) return;

    let startTime;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * target));
      if (progress < 1) requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, [end, duration, isVisible]);

  return count;
};

/* ==================== MODALS ==================== */
const TeamModal = ({ visible, onClose }) => {
  const sections = [
    { title: "Nos Fondateurs", icon: <CrownOutlined />, color: C.orange,
      desc: "D'anciens consultants et gestionnaires dans des multinationales, qui ont fondé Nomidya avec la mission de partager leurs connaissances." },
    { title: "Nos Formateurs", icon: <BookOutlined />, color: C.green,
      desc: "Soigneusement sélectionnés, ce sont des experts du secteur, dotés d'une vaste expérience pratique." },
    { title: "Équipe Technique", icon: <ToolOutlined />, color: C.blue,
      desc: "Travaille sans relâche pour maintenir notre plateforme à la pointe de la technologie." },
    { title: "Support Apprenants", icon: <CustomerServiceOutlined />, color: "#DC2626",
      desc: "Là pour guider, accompagner et répondre aux questions de nos apprenants." },
  ];

  return (
    <Modal open={visible} onCancel={onClose} footer={null} width={720} centered closeIcon={<CloseOutlined />} title={null}>
      <div style={{ padding: "8px 0" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px", background: C.blue, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "white" }}>
            <TeamOutlined />
          </div>
          <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
            L'équipe <span style={{ color: C.orange }}>Nomidya</span>
          </h2>
        </div>
        <Row gutter={[12, 12]}>
          {sections.map((s, i) => (
            <Col xs={24} sm={12} key={i}>
              <div style={{ padding: 16, borderRadius: 10, border: `1px solid ${C.border}`, borderLeft: `3px solid ${s.color}`, background: "white", height: "100%" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <div style={{ width: 34, height: 34, borderRadius: 10, background: s.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, color: "white" }}>{s.icon}</div>
                  <span style={{ fontSize: 14, fontWeight: 700, color: C.blueDark }}>{s.title}</span>
                </div>
                <p style={{ margin: 0, fontSize: 12, color: C.textLight, lineHeight: 1.55 }}>{s.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Modal>
  );
};

const AboutModal = ({ visible, onClose }) => (
  <Modal open={visible} onCancel={onClose} footer={null} width={720} centered closeIcon={<CloseOutlined />} title={null}>
    <div style={{ padding: "8px 0" }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ width: 48, height: 48, borderRadius: 14, margin: "0 auto 12px", background: C.orange, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, color: "white" }}>
          <FileTextOutlined />
        </div>
        <h2 style={{ color: C.blueDark, fontSize: 24, fontWeight: 800, margin: "0 0 4px" }}>
          À Propos de <span style={{ color: C.orange }}>Nomidya</span>
        </h2>
      </div>
      <p style={{ fontSize: 13, color: C.text, lineHeight: 1.7, textAlign: "center", padding: "0 20px" }}>
        Nomidya est une plateforme e-learning fondée par d'anciens consultants SAP. Notre mission : démocratiser
        l'apprentissage SAP de qualité avec des formations pratiques basées sur des cas réels.
      </p>
    </div>
  </Modal>
);

/* ==================== HOMEPAGE PRO ==================== */
const HomePage = () => {
  const navigate = useNavigate();
  const [teamVisible, setTeamVisible] = useState(false);
  const [aboutVisible, setAboutVisible] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterLoading, setNewsletterLoading] = useState(false);
  const statsRef = useRef(null);

  // ⭐ STATS DYNAMIQUES depuis BDD
  const [dynamicStats, setDynamicStats] = useState({
    apprenants: 1500,
    cours: 200,
    instructeurs: 50,
    satisfaction: 98,
  });

  useScrollAnimation();

  // Compteurs animés (utilisent les valeurs dynamiques)
  const apprenants = useCounter(dynamicStats.apprenants, 2000, statsVisible);
  const cours = useCounter(dynamicStats.cours, 1800, statsVisible);
  const instructeurs = useCounter(dynamicStats.instructeurs, 1500, statsVisible);
  const satisfaction = useCounter(dynamicStats.satisfaction, 1700, statsVisible);

  // Charger les vraies stats depuis la BDD
  useEffect(() => {
    (async () => {
      try {
        // Cours total depuis le service public
        const allCourses = await publicCourseService.getCourseSummary();
        const coursCount = Array.isArray(allCourses) ? allCourses.length : 0;
        
        // Récupérer instructeurs uniques (créateurs distincts)
        const uniqueCreators = allCourses ? 
          [...new Set(allCourses.map(c => c.createdBy).filter(Boolean))].length : 0;

        setDynamicStats(prev => ({
          ...prev,
          cours: coursCount > 0 ? coursCount : prev.cours,
          instructeurs: uniqueCreators > 0 ? uniqueCreators : prev.instructeurs,
        }));
      } catch (e) {
        console.error("Erreur stats:", e);
      }
    })();
  }, []);

  // Observer pour démarrer les compteurs
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setStatsVisible(true),
      { threshold: 0.3 }
    );
    if (statsRef.current) observer.observe(statsRef.current);
    return () => statsRef.current && observer.unobserve(statsRef.current);
  }, []);

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (!newsletterEmail || !newsletterEmail.includes('@')) {
      message.error("Veuillez entrer un email valide");
      return;
    }
    setNewsletterLoading(true);
    setTimeout(() => {
      message.success("🎉 Merci ! Vous êtes inscrit à notre newsletter.");
      setNewsletterEmail("");
      setNewsletterLoading(false);
    }, 1000);
  };

  /* Témoignages fictifs réalistes */
  const testimonials = [
    {
      name: "Sophie Martin",
      role: "Consultante SAP FI/CO",
      avatar: "👩‍💼",
      rating: 5,
      text: "Grâce à Nomidya, j'ai obtenu ma certification SAP en 3 mois. Les formateurs sont d'excellents experts et l'accès SAP dédié est un vrai plus pour pratiquer.",
      company: "Capgemini",
    },
    {
      name: "Ahmed Bencheikh",
      role: "Chef de Projet SAP",
      avatar: "👨‍💼",
      rating: 5,
      text: "La meilleure plateforme e-learning SAP que j'ai utilisée. Contenu de qualité, support réactif et certificats reconnus par les recruteurs.",
      company: "Deloitte",
    },
    {
      name: "Marie Dubois",
      role: "Analyste BW/HANA",
      avatar: "👩‍💻",
      rating: 5,
      text: "L'accès aux systèmes SAP réels fait toute la différence. J'ai appris en pratiquant, ce qui m'a permis de décrocher mon poste actuel.",
      company: "Accenture",
    },
  ];

  /* ⭐ Process en 3 étapes - AVEC ACTIONS */
  const steps = [
    { 
      num: "01", icon: <UserOutlined />, 
      title: "Inscrivez-vous", 
      desc: "Créez votre compte gratuitement en 30 secondes", 
      color: C.blue,
      onClick: () => {
        const user = JSON.parse(localStorage.getItem('user') || 'null');
        if (user) {
          navigate('/profile');
        } else {
          navigate('/login');
        }
      },
    },
    { 
      num: "02", icon: <BookOutlined />, 
      title: "Apprenez", 
      desc: "Accédez aux cours et systèmes SAP réels 24/7", 
      color: C.orange,
      onClick: () => navigate('/courses'),
    },
    { 
      num: "03", icon: <TrophyOutlined />, 
      title: "Certifiez-vous", 
      desc: "Obtenez votre certificat reconnu par les recruteurs", 
      color: C.green,
      onClick: () => navigate('/courses'),
    },
  ];

  /* FAQ inline */
  const faqs = [
    { q: "Comment se déroule une formation Nomidya ?", a: "Nos formations combinent vidéos HD, exercices pratiques sur SAP réel, quiz interactifs et certifications. Vous apprenez à votre rythme avec un accès 24/7." },
    { q: "L'accès SAP S/4 HANA est-il vraiment inclus ?", a: "Oui ! Avec nos plans Premium, vous avez un accès dédié à des systèmes SAP S/4 HANA réels, pas des simulations. Pratiquez sur les modules MM, SD, FI/CO, etc." },
    { q: "Combien de temps pour devenir consultant SAP ?", a: "En moyenne 3 à 6 mois en suivant nos parcours complets. Le rythme dépend de votre disponibilité (3-5h/semaine recommandées)." },
    { q: "Les certificats sont-ils reconnus ?", a: "Oui, nos certificats sont valorisés par les recruteurs et entreprises (Capgemini, Deloitte, Accenture...). Ils attestent de vos compétences pratiques." },
    { q: "Y a-t-il un support en cas de problème ?", a: "Absolument ! Notre équipe support répond sous 24h. De plus, les formateurs sont disponibles pour répondre aux questions techniques." },
    { q: "Qu'est-ce qu'une formation Live ?", a: "Les formations Live sont des sessions interactives en direct avec nos experts via Zoom/Teams. Vous posez vos questions en temps réel, participez aux ateliers pratiques et bénéficiez d'un suivi personnalisé. Idéal pour approfondir un sujet spécifique." },
  ];

  return (
    <Layout style={{ minHeight: "100vh", background: C.white }}>
      <style>{`
        @keyframes float-bg { 0%, 100% { transform: translateY(0) rotate(0deg); } 50% { transform: translateY(-20px) rotate(2deg); } }
        @keyframes fade-up { from { opacity: 0; transform: translateY(40px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pulse-orange { 0%, 100% { box-shadow: 0 0 0 0 rgba(232,134,12,0.4); } 50% { box-shadow: 0 0 0 15px rgba(232,134,12,0); } }
        @keyframes scale-in { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }
        @keyframes pulse-soft { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }

        .hero-cta-primary { animation: pulse-orange 2s infinite; }
        
        .animate-on-scroll {
          opacity: 0;
          transform: translateY(40px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }
        .animate-on-scroll.animate-visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .feature-card { transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1); }
        .feature-card:hover { 
          transform: translateY(-8px) scale(1.02); 
          box-shadow: 0 25px 50px rgba(0,84,166,0.15) !important; 
        }

        .step-card { 
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }
        .step-card:hover { 
          transform: translateY(-8px); 
          box-shadow: 0 25px 50px rgba(0,84,166,0.18) !important;
        }
        .step-card:hover .step-arrow {
          transform: translateX(8px);
          opacity: 1;
        }
        .step-arrow {
          opacity: 0;
          transition: all 0.3s ease;
        }
        
        .testimonial-card { transition: all 0.4s ease; }
        .testimonial-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 40px rgba(0,84,166,0.12) !important;
        }
        
        .step-number {
          font-size: 80px;
          font-weight: 900;
          opacity: 0.1;
          position: absolute;
          top: -10px;
          right: 20px;
          line-height: 1;
        }

        @media (max-width: 768px) {
          .hero-title { font-size: 32px !important; }
          .section-title { font-size: 24px !important; }
        }
      `}</style>

      <Content style={{ background: C.white, padding: 0 }}>

        {/* ============ 1. HERO IMPACT ============ */}
        <div style={{
          background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%)`,
          padding: "80px 24px 60px",
          color: "white",
          position: "relative",
          overflow: "hidden",
        }}>
          <div style={{
            position: "absolute", top: -100, right: -100, width: 400, height: 400,
            background: `radial-gradient(circle, ${C.orange}33 0%, transparent 70%)`,
            borderRadius: "50%", animation: "float-bg 8s ease-in-out infinite",
          }} />
          <div style={{
            position: "absolute", bottom: -150, left: -50, width: 300, height: 300,
            background: `radial-gradient(circle, ${C.blue}66 0%, transparent 70%)`,
            borderRadius: "50%", animation: "float-bg 10s ease-in-out infinite reverse",
          }} />

          <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1, animation: "fade-up 0.8s ease-out" }}>
            <Row gutter={[40, 40]} align="middle">
              <Col xs={24} md={14}>
                <div style={{
                  display: "inline-flex", alignItems: "center", gap: 8,
                  background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                  padding: "8px 18px", borderRadius: 30, fontSize: 12, fontWeight: 700,
                  letterSpacing: 1.2, marginBottom: 24, boxShadow: `0 4px 12px ${C.orange}66`,
                }}>
                  <FireOutlined /> PLATEFORME N°1 EN FORMATION SAP
                </div>

               <h1 className="hero-title" style={{
    fontSize: 52, fontWeight: 900, lineHeight: 1.1, margin: "0 0 20px",
    letterSpacing: -1, textShadow: "0 2px 10px rgba(0,0,0,0.2)",
}}>
    Devenez expert dans <span style={{
        background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
        WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    }}>toutes les versions</span> en quelques mois
</h1>

                <p style={{ fontSize: 17, opacity: 0.9, lineHeight: 1.7, marginBottom: 32, maxWidth: 540 }}>
                  Plateforme e-learning premium avec accès SAP dédiés, formateurs experts
                  et certifications reconnues. Lancez votre carrière SAP dès aujourd'hui.
                </p>

                <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginBottom: 32 }}>
                  <button onClick={() => navigate('/courses')} className="hero-cta-primary"
                    style={{
                      padding: "16px 32px", borderRadius: 12, border: "none",
                      background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                      color: "white", fontSize: 15, fontWeight: 700, cursor: "pointer",
                      display: "flex", alignItems: "center", gap: 10,
                      boxShadow: `0 8px 24px ${C.orange}66`, transition: "all 0.3s",
                    }}
                    onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                    onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}>
                    <BookOutlined /> Explorer les cours <ArrowRightOutlined />
                  </button>

                  <button onClick={() => navigate('/sap-access')}
                    style={{
                      padding: "16px 32px", borderRadius: 12,
                      border: "2px solid rgba(255,255,255,0.3)",
                      background: "rgba(255,255,255,0.1)", color: "white",
                      fontSize: 15, fontWeight: 600, cursor: "pointer",
                      display: "flex", alignItems: "center", gap: 10,
                      backdropFilter: "blur(10px)", transition: "all 0.3s",
                    }}>
                    <RocketOutlined /> Accès SAP S/4 HANA
                  </button>
                </div>

                <div style={{ display: "flex", gap: 32, flexWrap: "wrap", paddingTop: 20, borderTop: "1px solid rgba(255,255,255,0.15)" }}>
                  {[
                    { value: `${dynamicStats.apprenants}+`, label: "Apprenants" },
                    { value: `${dynamicStats.cours}+`, label: "Cours" },
                    { value: "175", label: "Pays" },
                    { value: "98%", label: "Satisfaction" },
                  ].map((s, i) => (
                    <div key={i}>
                      <div style={{ fontSize: 24, fontWeight: 800, color: C.orangeLight }}>{s.value}</div>
                      <div style={{ fontSize: 11, opacity: 0.7, textTransform: "uppercase", letterSpacing: 1 }}>{s.label}</div>
                    </div>
                  ))}
                </div>
              </Col>

              <Col xs={24} md={10}>
                <div style={{ position: "relative", padding: "30px", animation: "scale-in 0.8s ease-out 0.3s backwards" }}>
                  <div style={{
                    background: "rgba(255,255,255,0.1)", backdropFilter: "blur(20px)",
                    border: "1px solid rgba(255,255,255,0.2)", borderRadius: 24,
                    padding: 40, textAlign: "center",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                  }}>
                    <div style={{
                      width: 120, height: 120, margin: "0 auto 24px",
                      background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                      borderRadius: 24, display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 60, boxShadow: `0 12px 40px ${C.orange}66`,
                    }}>
                      🎓
                    </div>
                    <h3 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 12px" }}>Apprentissage Premium</h3>
                    <p style={{ fontSize: 14, opacity: 0.85, margin: "0 0 20px", lineHeight: 1.6 }}>
                      Accès illimité, certificats reconnus, support 7j/7
                    </p>
                    <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                      {["✓ HD Vidéos", "✓ Quiz interactifs", "✓ Certificats"].map((f, i) => (
                        <div key={i} style={{
                          fontSize: 11, padding: "6px 12px", borderRadius: 20,
                          background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.2)",
                        }}>{f}</div>
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* ============ 2. COMMENT ÇA MARCHE (CLIQUABLES) ============ */}
        <div className="animate-on-scroll" style={{ padding: "80px 24px", background: C.white }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <span style={{
                fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
                textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
                background: C.orangeBg, display: "inline-block", marginBottom: 12,
              }}>
                Simple & Efficace
              </span>
              <h2 className="section-title" style={{ fontSize: 36, fontWeight: 800, color: C.blueDark, margin: "8px 0 12px" }}>
                Comment ça <span style={{ color: C.orange }}>marche ?</span>
              </h2>
              <p style={{ fontSize: 16, color: C.textLight, maxWidth: 600, margin: "0 auto" }}>
                3 étapes simples pour transformer votre carrière SAP — Cliquez pour démarrer !
              </p>
            </div>

            <Row gutter={[24, 24]}>
              {steps.map((step, i) => (
                <Col xs={24} md={8} key={i}>
                  <div className="step-card" onClick={step.onClick} style={{
                    padding: "40px 28px", borderRadius: 20, background: "white",
                    border: `1px solid ${C.border}`, height: "100%", position: "relative",
                    overflow: "hidden", boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                  }}>
                    <div className="step-number" style={{ color: step.color }}>{step.num}</div>
                    <div style={{
                      width: 64, height: 64, borderRadius: 16, marginBottom: 20,
                      background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}dd 100%)`,
                      color: "white", display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 28, boxShadow: `0 8px 24px ${step.color}44`,
                    }}>
                      {step.icon}
                    </div>
                    <h3 style={{ fontSize: 20, fontWeight: 700, color: C.blueDark, margin: "0 0 10px" }}>
                      {step.title}
                    </h3>
                    <p style={{ fontSize: 14, color: C.textLight, lineHeight: 1.6, margin: "0 0 16px" }}>
                      {step.desc}
                    </p>
                    <div className="step-arrow" style={{ 
                      display: "inline-flex", alignItems: "center", gap: 8,
                      color: step.color, fontWeight: 700, fontSize: 13,
                    }}>
                      Commencer <ArrowRightOutlined />
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ============ 3. ACCÈS SAP DÉDIÉS ============ */}
        <div className="animate-on-scroll">
          <DedicatedAccessSection />
        </div>

        {/* ============ 4. CATALOGUE COURS (Apprenez avec les meilleurs instructeurs) ============ */}
        <div className="animate-on-scroll" style={{ padding: "60px 20px", background: C.bg }}>
          <CoursesByCategory />
        </div>

        {/* ============ 5. FORMATIONS LIVE (info uniquement, pas de "aucune") ============ */}
        <div className="animate-on-scroll" style={{
          padding: "60px 24px",
          background: `linear-gradient(135deg, #fff5f5 0%, #ffe5e8 100%)`,
        }}>
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <span style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                fontSize: 11, fontWeight: 700, color: "white", letterSpacing: 1.5,
                textTransform: "uppercase", padding: "5px 14px", borderRadius: 20,
                background: "linear-gradient(135deg, #ee5a6f, #ff6b6b)",
                marginBottom: 12, boxShadow: "0 4px 12px rgba(238,90,111,0.4)",
              }}>
                <span style={{
                  width: 8, height: 8, background: "white", borderRadius: "50%",
                  animation: "pulse-soft 1.5s infinite",
                }} />
                NOUVEAU - SESSIONS EN DIRECT
              </span>
              <h2 className="section-title" style={{ fontSize: 32, fontWeight: 800, color: C.blueDark, margin: "8px 0 6px" }}>
                Formations <span style={{ color: "#ee5a6f" }}>Live</span> avec nos experts
              </h2>
              <p style={{ fontSize: 14, color: C.textLight, maxWidth: 700, margin: "0 auto" }}>
                Sessions interactives en direct avec questions/réponses en temps réel
              </p>
            </div>

            <Row gutter={[20, 20]} align="stretch">
              {/* Card 1 : Description du service */}
              <Col xs={24} md={12}>
                <div style={{
                  background: "white", borderRadius: 16, padding: 28,
                  border: "1px solid #ffd1d6", height: "100%",
                  boxShadow: "0 4px 12px rgba(238,90,111,0.08)",
                }}>
                  <div style={{
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    width: 56, height: 56, borderRadius: 14, marginBottom: 20,
                    background: "linear-gradient(135deg, #ee5a6f, #ff6b6b)",
                    color: "white", fontSize: 26,
                    boxShadow: "0 8px 20px rgba(238,90,111,0.3)",
                  }}>
                    <VideoCameraOutlined />
                  </div>
                  <h3 style={{ fontSize: 20, fontWeight: 800, color: C.blueDark, margin: "0 0 14px" }}>
                    Apprentissage en direct
                  </h3>
                  <p style={{ fontSize: 14, color: C.text, lineHeight: 1.7, marginBottom: 16 }}>
                    Participez à des <strong>sessions live interactives</strong> avec nos experts SAP.
                    Posez vos questions en temps réel et bénéficiez d'un apprentissage personnalisé via Zoom, Teams ou Google Meet.
                  </p>
                  
                  <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
                    {[
                      { icon: "🎥", text: "Sessions Zoom/Teams/Meet" },
                      { icon: "💬", text: "Q&A en direct avec l'expert" },
                      { icon: "📺", text: "Replay disponible" },
                      { icon: "👥", text: "Groupes restreints (max 30)" },
                    ].map((item, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: C.text }}>
                        <span style={{ fontSize: 18 }}>{item.icon}</span>
                        <span>{item.text}</span>
                      </div>
                    ))}
                  </div>

                  <button onClick={() => navigate('/live-trainings')} style={{
                    padding: "12px 28px", borderRadius: 30, border: "none",
                    background: "linear-gradient(135deg, #ee5a6f, #ff6b6b)",
                    color: "white", fontSize: 13, fontWeight: 700, cursor: "pointer",
                    display: "inline-flex", alignItems: "center", gap: 8,
                    boxShadow: "0 4px 14px rgba(238,90,111,0.4)",
                    transition: "all 0.3s",
                  }}
                    onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                    onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}>
                    Voir les sessions disponibles <ArrowRightOutlined />
                  </button>
                </div>
              </Col>

              {/* Card 2 : Avantages du Live */}
              <Col xs={24} md={12}>
                <div style={{
                  background: "linear-gradient(135deg, #ee5a6f, #ff6b6b)",
                  borderRadius: 16, padding: 28, color: "white",
                  height: "100%", position: "relative", overflow: "hidden",
                  boxShadow: "0 8px 24px rgba(238,90,111,0.3)",
                }}>
                  <div style={{
                    position: "absolute", top: -40, right: -40, width: 150, height: 150,
                    background: "rgba(255,255,255,0.1)", borderRadius: "50%",
                  }} />
                  <div style={{ position: "relative", zIndex: 1 }}>
                    <h3 style={{ fontSize: 20, fontWeight: 800, margin: "0 0 16px" }}>
                      <ThunderboltOutlined /> Pourquoi le Live ?
                    </h3>
                    <p style={{ fontSize: 14, lineHeight: 1.7, marginBottom: 24, opacity: 0.95 }}>
                      Idéal pour <strong>approfondir un sujet spécifique</strong>, poser vos questions techniques 
                      et bénéficier de l'expertise directe de consultants SAP en activité.
                    </p>

                    <div style={{ display: "grid", gap: 14 }}>
                      {[
                        { stat: "100%", label: "Interaction directe avec l'expert" },
                        { stat: "0", label: "Question sans réponse" },
                        { stat: "30", label: "Apprenants max par session" },
                      ].map((item, i) => (
                        <div key={i} style={{
                          padding: 14, background: "rgba(255,255,255,0.15)",
                          borderRadius: 10, backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255,255,255,0.2)",
                        }}>
                          <div style={{ fontSize: 24, fontWeight: 800, color: "white" }}>
                            {item.stat}
                          </div>
                          <div style={{ fontSize: 12, opacity: 0.9 }}>{item.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* ============ 6. POURQUOI NOMIDYA ? ============ */}
        <div className="animate-on-scroll" style={{ padding: "80px 24px", background: C.white }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <span style={{
                fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
                textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
                background: C.orangeBg, display: "inline-block", marginBottom: 12,
              }}>
                Pourquoi nous choisir
              </span>
              <h2 className="section-title" style={{ fontSize: 36, fontWeight: 800, color: C.blueDark, margin: "8px 0 12px" }}>
                Une plateforme conçue pour <span style={{ color: C.orange }}>votre réussite</span>
              </h2>
            </div>

            <Row gutter={[24, 24]}>
              {[
                { icon: <SafetyCertificateOutlined />, title: "Certificats reconnus", desc: "Obtenez des certifications valorisées par les recruteurs SAP du monde entier.", color: C.blue },
                { icon: <RocketOutlined />, title: "Accès SAP réels", desc: "Pratiquez sur de vrais systèmes SAP S/4 HANA dédiés, pas de simulations.", color: C.orange },
                { icon: <TeamOutlined />, title: "Formateurs experts", desc: "Apprenez avec d'anciens consultants ayant 10+ ans d'expérience terrain.", color: C.green },
                { icon: <ClockCircleOutlined />, title: "Apprentissage flexible", desc: "Étudiez à votre rythme, 24/7, depuis n'importe quel appareil.", color: "#7C3AED" },
              ].map((f, i) => (
                <Col xs={24} sm={12} lg={6} key={i}>
                  <div className="feature-card" style={{
                    padding: "32px 24px", borderRadius: 16, background: "white",
                    border: `1px solid ${C.border}`, height: "100%", textAlign: "center",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  }}>
                    <div style={{
                      width: 64, height: 64, borderRadius: 16, margin: "0 auto 20px",
                      background: `${f.color}15`, color: f.color,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 28, border: `2px solid ${f.color}33`,
                    }}>
                      {f.icon}
                    </div>
                    <h3 style={{ fontSize: 17, fontWeight: 700, color: C.blueDark, margin: "0 0 10px" }}>
                      {f.title}
                    </h3>
                    <p style={{ fontSize: 13, color: C.textLight, lineHeight: 1.6, margin: 0 }}>
                      {f.desc}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ============ 7. TÉMOIGNAGES ============ */}
        <div className="animate-on-scroll" style={{ padding: "60px 24px", background: C.bg }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <span style={{
                fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
                textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
                background: C.orangeBg, display: "inline-block", marginBottom: 12,
              }}>
                💬 Témoignages
              </span>
              <h2 className="section-title" style={{ fontSize: 32, fontWeight: 800, color: C.blueDark, margin: "8px 0 6px" }}>
                Ce qu'en pensent <span style={{ color: C.orange }}>nos apprenants</span>
              </h2>
            </div>

            <Row gutter={[24, 24]}>
              {testimonials.map((t, i) => (
                <Col xs={24} md={8} key={i}>
                  <div className="testimonial-card" style={{
                    padding: "28px 24px", borderRadius: 16, background: "white",
                    border: `1px solid ${C.border}`, height: "100%", position: "relative",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                  }}>
                    <div style={{
                      position: "absolute", top: 20, right: 20,
                      fontSize: 60, color: C.orange, opacity: 0.15, lineHeight: 1,
                      fontFamily: "serif", fontWeight: 900,
                    }}>
                      "
                    </div>

                    <div style={{ marginBottom: 16, color: "#FFC107", fontSize: 16 }}>
                      {"⭐".repeat(t.rating)}
                    </div>

                    <p style={{ fontSize: 14, color: C.text, lineHeight: 1.7, marginBottom: 20, fontStyle: "italic" }}>
                      "{t.text}"
                    </p>

                    <div style={{ display: "flex", alignItems: "center", gap: 12, paddingTop: 16, borderTop: `1px solid ${C.border}` }}>
                      <div style={{
                        width: 48, height: 48, borderRadius: "50%",
                        background: `linear-gradient(135deg, ${C.blue}, ${C.orange})`,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 24, flexShrink: 0,
                      }}>
                        {t.avatar}
                      </div>
                      <div>
                        <div style={{ fontSize: 14, fontWeight: 700, color: C.blueDark }}>{t.name}</div>
                        <div style={{ fontSize: 11, color: C.textLight }}>{t.role}</div>
                        <div style={{ fontSize: 10, color: C.orange, fontWeight: 600 }}>{t.company}</div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ============ 8. STATISTIQUES (DYNAMIQUES) ============ */}
        <div ref={statsRef} className="animate-on-scroll" style={{
          background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 100%)`,
          padding: "60px 24px", position: "relative", overflow: "hidden",
        }}>
          <div style={{
            position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
            backgroundImage: `radial-gradient(circle at 80% 30%, ${C.orange}22 0%, transparent 50%)`,
            pointerEvents: "none",
          }} />
          <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <h2 className="section-title" style={{ color: "white", fontSize: 32, fontWeight: 800, margin: "0 0 12px" }}>
                Rejoignez plus de <span style={{ color: C.orangeLight }}>{dynamicStats.apprenants.toLocaleString()} apprenants</span>
              </h2>
            </div>
            <Row gutter={[20, 20]}>
              {[
                { value: apprenants, suffix: "+", label: "Apprenants actifs", icon: <UserOutlined /> },
                { value: cours, suffix: "+", label: "Cours disponibles", icon: <ReadOutlined /> },
                { value: instructeurs, suffix: "+", label: "Instructeurs experts", icon: <TeamOutlined /> },
                { value: satisfaction, suffix: "%", label: "Taux de satisfaction", icon: <LineChartOutlined /> },
              ].map((stat, i) => (
                <Col xs={12} sm={6} key={i}>
                  <div style={{
                    textAlign: "center", padding: "28px 16px", borderRadius: 16,
                    background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.1)",
                    transition: "all 0.3s",
                  }}
                    onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.14)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.08)"; e.currentTarget.style.transform = "translateY(0)"; }}
                  >
                    <div style={{
                      width: 52, height: 52, borderRadius: 14, margin: "0 auto 12px",
                      background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 22, color: "white", boxShadow: `0 6px 20px ${C.orange}66`,
                    }}>{stat.icon}</div>
                    <div style={{ fontSize: 36, fontWeight: 800, color: "white", marginBottom: 4 }}>
                      {stat.value.toLocaleString()}{stat.suffix}
                    </div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", textTransform: "uppercase", letterSpacing: 1 }}>{stat.label}</div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ============ 9. NEWS ============ */}
        <div className="animate-on-scroll">
          <NewsSection />
        </div>

        {/* ============ 10. NEWSLETTER ============ */}
        <div className="animate-on-scroll" style={{
          padding: "60px 24px",
          background: `linear-gradient(135deg, ${C.blue} 0%, ${C.blueDark} 100%)`,
          color: "white", position: "relative", overflow: "hidden",
        }}>
          <div style={{
            position: "absolute", top: -50, right: -50, width: 200, height: 200,
            background: `radial-gradient(circle, ${C.orange}33 0%, transparent 70%)`,
            borderRadius: "50%",
          }} />
          <div style={{ maxWidth: 700, margin: "0 auto", textAlign: "center", position: "relative", zIndex: 1 }}>
            <div style={{
              width: 64, height: 64, borderRadius: 16, margin: "0 auto 20px",
              background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 28, boxShadow: `0 8px 24px ${C.orange}66`,
            }}>
              <MailOutlined />
            </div>
            <h2 style={{ fontSize: 28, fontWeight: 800, margin: "0 0 12px" }}>
              Restez à la pointe du <span style={{ color: C.orangeLight }}>SAP</span>
            </h2>
            <p style={{ fontSize: 15, opacity: 0.9, marginBottom: 28, lineHeight: 1.6 }}>
              Recevez nos derniers cours, actualités SAP et conseils carrière directement dans votre boîte mail.
            </p>
            <form onSubmit={handleNewsletter} style={{
              display: "flex", gap: 10, maxWidth: 500, margin: "0 auto", flexWrap: "wrap",
            }}>
              <input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                placeholder="Votre email professionnel"
                style={{
                  flex: 1, minWidth: 250, padding: "14px 18px", borderRadius: 12,
                  border: "2px solid rgba(255,255,255,0.2)",
                  background: "rgba(255,255,255,0.1)", color: "white",
                  fontSize: 14, outline: "none",
                  backdropFilter: "blur(10px)",
                }}
              />
              <button type="submit" disabled={newsletterLoading} style={{
                padding: "14px 28px", borderRadius: 12, border: "none",
                background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
                color: "white", fontSize: 14, fontWeight: 700, cursor: "pointer",
                display: "flex", alignItems: "center", gap: 8,
                boxShadow: `0 4px 12px ${C.orange}66`,
              }}>
                {newsletterLoading ? "..." : <><SendOutlined /> S'inscrire</>}
              </button>
            </form>
            <p style={{ fontSize: 11, opacity: 0.6, marginTop: 14 }}>
              🔒 Pas de spam. Désinscription en 1 clic.
            </p>
          </div>
        </div>

        {/* ============ 11. FAQ ============ */}
        <div className="animate-on-scroll" style={{ padding: "60px 24px", background: C.white }}>
          <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <span style={{
                fontSize: 11, fontWeight: 700, color: C.orange, letterSpacing: 1.5,
                textTransform: "uppercase", padding: "4px 14px", borderRadius: 12,
                background: C.orangeBg, display: "inline-block", marginBottom: 12,
              }}>
                ❓ Questions fréquentes
              </span>
              <h2 className="section-title" style={{ fontSize: 32, fontWeight: 800, color: C.blueDark, margin: "8px 0 6px" }}>
                Tout ce que vous voulez <span style={{ color: C.orange }}>savoir</span>
              </h2>
            </div>

            <Collapse accordion expandIconPosition="end" bordered={false}
              style={{ background: "transparent" }}>
              {faqs.map((faq, i) => (
                <Panel key={i}
                  header={
                    <span style={{ fontSize: 15, fontWeight: 600, color: C.blueDark }}>
                      {faq.q}
                    </span>
                  }
                  style={{
                    marginBottom: 12, borderRadius: 12, overflow: "hidden",
                    border: `1px solid ${C.border}`, background: "white",
                  }}>
                  <p style={{ margin: 0, fontSize: 14, color: C.text, lineHeight: 1.7 }}>
                    {faq.a}
                  </p>
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>

        {/* ============ 12. DÉCOUVREZ NOMIDYA ============ */}
        <div className="animate-on-scroll" style={{ padding: "60px 24px", background: C.bg }}>
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 40 }}>
              <h2 className="section-title" style={{ fontSize: 32, fontWeight: 800, color: C.blueDark, margin: "8px 0 6px" }}>
                Découvrez <span style={{ color: C.orange }}>Nomidya</span>
              </h2>
              <p style={{ fontSize: 14, color: C.textLight, margin: 0 }}>
                Notre plateforme, notre mission, notre équipe
              </p>
            </div>

            <Row gutter={[20, 20]} justify="center">
              {[
                { icon: <TeamOutlined />, title: "Notre Équipe", desc: "Rencontrez les experts qui rendent l'apprentissage possible", btn: "Découvrir", color: C.blue, onClick: () => setTeamVisible(true) },
                { icon: <FileTextOutlined />, title: "À Propos", desc: "Notre histoire, mission et valeurs", btn: "En savoir plus", color: C.orange, onClick: () => setAboutVisible(true) },
              ].map((item, i) => (
                <Col xs={24} sm={12} key={i}>
                  <div className="feature-card"
                    onClick={item.onClick}
                    style={{
                      textAlign: "center", borderRadius: 16, padding: "32px 24px",
                      background: "white", border: `1px solid ${C.border}`,
                      cursor: "pointer", boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                    }}
                  >
                    <div style={{
                      width: 56, height: 56, borderRadius: 14, margin: "0 auto 16px",
                      background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontSize: 24, color: "white", boxShadow: `0 6px 20px ${item.color}44`,
                    }}>{item.icon}</div>
                    <h3 style={{ fontSize: 18, fontWeight: 700, color: C.blueDark, margin: "0 0 8px" }}>{item.title}</h3>
                    <p style={{ fontSize: 13, color: C.textLight, lineHeight: 1.6, marginBottom: 16, minHeight: 40 }}>{item.desc}</p>
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: 6,
                      padding: "8px 22px", borderRadius: 30, background: item.color,
                      color: "white", fontWeight: 600, fontSize: 13,
                    }}>
                      {item.btn} <ArrowRightOutlined />
                    </span>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>

        {/* ============ 13. CTA FINAL ============ */}
        <div style={{
          background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
          padding: "60px 24px", textAlign: "center", color: "white",
          position: "relative", overflow: "hidden",
        }}>
          <div style={{
            position: "absolute", top: 0, left: 0, width: "100%", height: "100%",
            backgroundImage: `radial-gradient(circle at 20% 50%, rgba(255,255,255,0.15) 0%, transparent 50%)`,
            pointerEvents: "none",
          }} />
          <div style={{ position: "relative", zIndex: 1, maxWidth: 700, margin: "0 auto" }}>
            <h2 style={{ fontSize: 36, fontWeight: 800, margin: "0 0 16px", textShadow: "0 2px 10px rgba(0,0,0,0.1)" }}>
              Prêt à transformer votre carrière ?
            </h2>
            <p style={{ fontSize: 17, opacity: 0.95, marginBottom: 32, maxWidth: 540, margin: "0 auto 32px" }}>
              Rejoignez la communauté Nomidya et commencez votre parcours SAP dès aujourd'hui.
            </p>
            <Space size="middle" wrap style={{ justifyContent: "center" }}>
              <button onClick={() => navigate('/register')} style={{
                padding: "16px 36px", borderRadius: 12, border: "none",
                background: "white", color: C.orange, fontSize: 15, fontWeight: 700,
                cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)", transition: "all 0.3s",
              }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-3px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}>
                <RocketOutlined /> Créer un compte gratuit
              </button>
              <button onClick={() => navigate('/courses')} style={{
                padding: "16px 36px", borderRadius: 12,
                border: "2px solid rgba(255,255,255,0.5)",
                background: "transparent", color: "white",
                fontSize: 15, fontWeight: 600, cursor: "pointer",
                display: "inline-flex", alignItems: "center", gap: 10,
              }}>
                <PlayCircleOutlined /> Voir les cours
              </button>
            </Space>
          </div>
        </div>
      </Content>

      <Footer style={{ textAlign: "center", background: C.blueDeep, padding: "32px 20px" }}>
        <img src="/img/nomidya.png" alt="Nomidya" style={{ height: 36, marginBottom: 12, opacity: 0.9 }}
          onError={e => { e.target.style.display = 'none'; }} />
        <p style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", margin: 0 }}>
          © 2026 Nomidya — La Carrière. Tous droits réservés.
        </p>
      </Footer>

      <TeamModal visible={teamVisible} onClose={() => setTeamVisible(false)} />
      <AboutModal visible={aboutVisible} onClose={() => setAboutVisible(false)} />
    </Layout>
  );
};

export default HomePage;